export enum FCompositionTypesEnum {
  FEnsemble = 0,
  FArrangement = 1,
}
